import React from 'react'
import {
  BooleanInput,
  Create,
  ImageField,
  ImageInput,
  SimpleForm,
  TextInput,
  ArrayInput,
  SimpleFormIterator,
  ReferenceInput,
  AutocompleteInput
} from 'react-admin'
import {required} from '../../validators'
import CreateActions from '../../custom/common/CreateActions'
import CreateToolbar from '../../custom/common/CreateToolbar'

export default (props) => (
  <Create {...props} actions={<CreateActions/>}>
    <SimpleForm
      toolbar={<CreateToolbar/>}
      defaultValue={{onDeal: false}}>
      <TextInput disabled source='id'/>
      <TextInput source="name" validate={required}/>
      <TextInput source="subname" label="이벤트 부제목"/>
      <BooleanInput source="onSale"/>
      <TextInput source="backgroundColor"/>
      <ImageInput source="desktopImage" accept="image/*" validate={required}>
        <ImageField source="src" title="title"/>
      </ImageInput>
      <ImageInput source="mobileImage" accept="image/*" validate={required}>
        <ImageField source="src" title="title"/>
      </ImageInput>
      <ImageInput source="appImage" accept="image/*">
        <ImageField source="src" title="title"/>
      </ImageInput>
      <ImageInput source="descriptionImage" accept="image/*">
        <ImageField source="src" title="title"/>
      </ImageInput>
      <ArrayInput source="blogs" addLabel={false}>
        <SimpleFormIterator>
          <ReferenceInput
            label={'resources.blogs.fields.id'}
            source="id"
            reference="blogs"
            perPage={10}
            alwaysOn
            validate={required}
          >
            <AutocompleteInput optionText="title" optionValue="id" />
          </ReferenceInput>
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  </Create>
)
